document.addEventListener("DOMContentLoaded", function () {
  const boardEl = document.getElementById("pp-board");
  const gridEl = document.getElementById("pp-board-grid");
  const boardModelSelect = document.getElementById("pp-board-model");
  const boardLabelEl = document.getElementById("pp-board-label");
  const boardMetaEl = document.getElementById("pp-board-meta");
  const selectedInfoEl = document.getElementById("pp-selected-info");
  const pedalButtons = document.querySelectorAll(".pp-pedal-btn");
  const clearBtn = document.getElementById("pp-clear");
  const deleteBtn = document.getElementById("pp-delete"); 
  const addCustomBtn = document.getElementById("pp-add-custom");
  const customNameInput = document.getElementById("pp-custom-name");
  const customWInput = document.getElementById("pp-custom-w");
  const customHInput = document.getElementById("pp-custom-h");

  const volumeToggleEl = document.getElementById("pp-volume-toggle");
  const volumeSideEl = document.getElementById("pp-volume-side");
  const volumeZoneEl = document.getElementById("pp-volume-zone");

  if (!boardEl) {
    // pagina senza configuratore → non fare nulla
    return;
  }

  let boardWidthCm = 37;
  let boardHeightCm = 31;
  let boardModelCode = "SB02";
  let pxPerCm = 6;

  // pedali
  let pedals = [];
  let dragState = null;
  let selectedPedalId = null;

  // helper: stato attuale kit
  function isVolumeEnabled() {
    return volumeToggleEl && volumeToggleEl.checked;
  }

  function getVolumeSide() {
    return volumeSideEl ? volumeSideEl.value : "right";
  }

  // dimensioni kit per modello
  function getVolumeDims() {
    if (boardModelCode === "SB03") {
      return { depth: 10, length: 13 }; // profondità verso fuori, lunghezza lungo il lato
    }
    // SB01 e SB02
    return { depth: 12, length: 28 };
  }

  function readBoardFromSelect() {
    const opt = boardModelSelect.selectedOptions[0];
    boardWidthCm = parseFloat(opt.dataset.width);
    boardHeightCm = parseFloat(opt.dataset.height);
    boardModelCode = opt.value;
    boardLabelEl.textContent =
      opt.value + " – " + boardWidthCm + " × " + boardHeightCm + " cm";
  }

  function updateMeta() {
    const volumeDims = getVolumeDims();
    let text =
      "Area pedaliera: " +
      (boardWidthCm * boardHeightCm).toFixed(0) +
      " cm²";

    if (isVolumeEnabled()) {
      text +=
        " · Kit volume: " +
        (volumeDims.depth * volumeDims.length).toFixed(0) +
        " cm² (" +
        volumeDims.depth +
        "×" +
        volumeDims.length +
        " cm)";
    }

    text +=
      " · Scala approssimativa 1:" + Math.round(100 / pxPerCm);

    boardMetaEl.textContent = text;
  }

  function updateVolumeZoneVisual() {
    if (!volumeZoneEl) return;

    if (!isVolumeEnabled()) {
      volumeZoneEl.style.display = "none";
      return;
    }

    const volumeDims = getVolumeDims();
    const depthPx = volumeDims.depth * pxPerCm;
    const lengthPx = volumeDims.length * pxPerCm;
    const boardMainWidthPx = boardWidthCm * pxPerCm;
    const boardHeightPx = boardHeightCm * pxPerCm;

    volumeZoneEl.style.display = "block";
    volumeZoneEl.style.width = depthPx + "px";
    volumeZoneEl.style.height = lengthPx + "px";

    const yStartPx = (boardHeightPx - lengthPx) / 2;
    volumeZoneEl.style.top = yStartPx + "px";

    if (getVolumeSide() === "right") {
      volumeZoneEl.style.left = boardMainWidthPx + "px";
    } else {
      volumeZoneEl.style.left = "0px";
    }
  }

  function recalcScaleAndResize() {
    const containerWidth = boardEl.parentElement.clientWidth;
    const volumeDims = getVolumeDims();
    const extraWidthCm = isVolumeEnabled() ? volumeDims.depth : 0;

    // scala calcolata solo sulla pedaliera principale
    const maxBoardWidthPx = containerWidth - 16;
    pxPerCm = maxBoardWidthPx / boardWidthCm;

    if (pxPerCm > 12) pxPerCm = 12;
    if (pxPerCm < 3) pxPerCm = 3;

    const widthPx = (boardWidthCm + extraWidthCm) * pxPerCm;
    const heightPx = boardHeightCm * pxPerCm;
    boardEl.style.width = widthPx + "px";
    boardEl.style.height = heightPx + "px";

    const gridStepPx = 5 * pxPerCm;
    gridEl.style.backgroundSize = gridStepPx + "px " + gridStepPx + "px";

    pedals.forEach((p) => {
      const el = document.querySelector('.pp-pedal[data-id="' + p.id + '"]');
      if (!el) return;
      el.style.width = p.wCm * pxPerCm + "px";
      el.style.height = p.hCm * pxPerCm + "px";
      el.style.left = p.xCm * pxPerCm + "px";
      el.style.top = p.yCm * pxPerCm + "px";
    });

    updateVolumeZoneVisual();
    updateMeta();
  }

  function getNewPedalPositionCm(wCm, hCm) {
    const xCm = Math.max(0, (boardWidthCm - wCm) / 2);
    const yCm = Math.max(0, (boardHeightCm - hCm) / 2);
    return { xCm, yCm };
  }

  // posizione per pedale volume dentro la placca laterale
  function getVolumeZonePositionCm(wCm, hCm) {
    const volumeDims = getVolumeDims();
    const depth = volumeDims.depth;
    const length = volumeDims.length;

    let zoneStartX;
    if (getVolumeSide() === "right") {
      zoneStartX = boardWidthCm; // subito dopo la pedaliera
    } else {
      zoneStartX = 0;
    }

    const yStart = Math.max(0, (boardHeightCm - length) / 2);

    const xCm =
      zoneStartX + Math.max(0, (depth - wCm) / 2);
    const yCm =
      yStart + Math.max(0, (length - hCm) / 2);

    return { xCm, yCm };
  }

  function createPedal(name, wCm, hCm, color) {
    const id = "pedal-" + Date.now() + "-" + Math.floor(Math.random() * 1000);

    let pos;
    if (name.toLowerCase().includes("volume") && isVolumeEnabled()) {
      pos = getVolumeZonePositionCm(wCm, hCm);
    } else {
      pos = getNewPedalPositionCm(wCm, hCm);
    }

    const el = document.createElement("div");
    el.className = "pp-pedal";
    el.dataset.id = id;
    el.style.background = color || "#4b5563";
    el.innerHTML = '<span class="pp-pedal-label">' + name + "</span>";
    boardEl.appendChild(el);

    const pedalData = {
      id,
      name,
      wCm,
      hCm,
      xCm: pos.xCm,
      yCm: pos.yCm,
      color: color || "#4b5563"
    };
    pedals.push(pedalData);

    makeDraggable(el);
    recalcScaleAndResize();
    selectPedal(id);
  }

  function selectPedal(id) {
    selectedPedalId = id;
    document.querySelectorAll(".pp-pedal").forEach((el) => {
      el.classList.toggle("selected", el.dataset.id === id);
    });
    const p = pedals.find((pd) => pd.id === id);
    if (!p) {
      selectedInfoEl.textContent = "Nessun pedale selezionato.";
      return;
    }

    let extra = "";
    if (p.name.toLowerCase().includes("volume") && isVolumeEnabled()) {
      extra = " · In zona KIT VOLUME.";
    }

    selectedInfoEl.textContent =
      "Selezionato: " +
      p.name +
      " – " +
      p.wCm +
      " × " +
      p.hCm +
      " cm · Posizione: " +
      p.xCm.toFixed(1) +
      " cm da sinistra, " +
      p.yCm.toFixed(1) +
      " cm dall'alto. Doppio clic per ruotare di 90°." +
      extra;
  }

  function deleteSelectedPedal() {
  if (!selectedPedalId) {
    selectedInfoEl.textContent = "Nessun pedale selezionato da eliminare.";
    return;
  }

  // rimuovi dai dati
  const index = pedals.findIndex((p) => p.id === selectedPedalId);
  if (index !== -1) {
    pedals.splice(index, 1);
  }

  // rimuovi dal DOM
  const el = document.querySelector('.pp-pedal[data-id="' + selectedPedalId + '"]');
  if (el && boardEl.contains(el)) {
    boardEl.removeChild(el);
  }

  // reset selezione
  selectedPedalId = null;
  selectedInfoEl.textContent = "Nessun pedale selezionato.";

  // opzionale: ridisegno (non strettamente necessario, ma safe)
  recalcScaleAndResize();
}


  function rotateSelectedPedal() {
    if (!selectedPedalId) return;
    const p = pedals.find((pd) => pd.id === selectedPedalId);
    if (!p) return;

    const oldW = p.wCm;
    const oldH = p.hCm;

    const centerX = p.xCm + oldW / 2;
    const centerY = p.yCm + oldH / 2;

    p.wCm = oldH;
    p.hCm = oldW;

    const volumeDims = getVolumeDims();
    const extraWidthCm = isVolumeEnabled() ? volumeDims.depth : 0;
    const effectiveWidthCm = boardWidthCm + extraWidthCm;

    let newX = centerX - p.wCm / 2;
    let newY = centerY - p.hCm / 2;

    newX = Math.max(0, Math.min(effectiveWidthCm - p.wCm, newX));
    newY = Math.max(0, Math.min(boardHeightCm - p.hCm, newY));

    p.xCm = newX;
    p.yCm = newY;

    recalcScaleAndResize();
    selectPedal(p.id);
  }

  function makeDraggable(el) {
    el.addEventListener("pointerdown", (ev) => {
      ev.preventDefault();
      const id = el.dataset.id;
      selectPedal(id);

      const boardRect = boardEl.getBoundingClientRect();
      const pedalRect = el.getBoundingClientRect();

      dragState = {
        id,
        startPointerX: ev.clientX,
        startPointerY: ev.clientY,
        startLeftPx: pedalRect.left - boardRect.left,
        startTopPx: pedalRect.top - boardRect.top
      };

      document.addEventListener("pointermove", onPointerMove);
      document.addEventListener("pointerup", onPointerUp);
    });

    el.addEventListener("dblclick", (ev) => {
      ev.preventDefault();
      selectPedal(el.dataset.id);
      rotateSelectedPedal();
    });
  }

  function onPointerMove(ev) {
    if (!dragState) return;

    const dx = ev.clientX - dragState.startPointerX;
    const dy = ev.clientY - dragState.startPointerY;

    let newLeft = dragState.startLeftPx + dx;
    let newTop = dragState.startTopPx + dy;

    const volumeDims = getVolumeDims();
    const extraWidthCm = isVolumeEnabled() ? volumeDims.depth : 0;
    const effectiveWidthCm = boardWidthCm + extraWidthCm;

    const boardWidthPx = effectiveWidthCm * pxPerCm;
    const boardHeightPx = boardHeightCm * pxPerCm;
    const el = document.querySelector('.pp-pedal[data-id="' + dragState.id + '"]');
    if (!el) return;

    const pedalWidthPx = el.offsetWidth;
    const pedalHeightPx = el.offsetHeight;

    newLeft = Math.max(0, Math.min(boardWidthPx - pedalWidthPx, newLeft));
    newTop = Math.max(0, Math.min(boardHeightPx - pedalHeightPx, newTop));

    el.style.left = newLeft + "px";
    el.style.top = newTop + "px";

    const p = pedals.find((pd) => pd.id === dragState.id);
    if (p) {
      p.xCm = newLeft / pxPerCm;
      p.yCm = newTop / pxPerCm;
      if (p.id === selectedPedalId) {
        selectPedal(p.id);
      }
    }
  }

  function onPointerUp() {
    document.removeEventListener("pointermove", onPointerMove);
    document.removeEventListener("pointerup", onPointerUp);
    dragState = null;
  }

  // EVENTI

  pedalButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const name = btn.dataset.pedal || "Pedal";
      const wCm = parseFloat(btn.dataset.w) || 12;
      const hCm = parseFloat(btn.dataset.h) || 7;
      const color = btn.dataset.color || "#4b5563";
      createPedal(name, wCm, hCm, color);
    });
  });

  if (addCustomBtn) {
    addCustomBtn.addEventListener("click", () => {
      const nameRaw = customNameInput.value.trim();
      const name = nameRaw || "Custom pedal";
      const wCm = Math.max(3, Math.min(40, parseFloat(customWInput.value) || 10));
      const hCm = Math.max(3, Math.min(40, parseFloat(customHInput.value) || 5));
      createPedal(name, wCm, hCm, "#eab308");
    });
  }

  boardModelSelect.addEventListener("change", () => {
    readBoardFromSelect();
    recalcScaleAndResize();
  });

  if (deleteBtn) {
  deleteBtn.addEventListener("click", deleteSelectedPedal);
}

clearBtn.addEventListener("click", () => {
  pedals = [];
  selectedPedalId = null;
  while (boardEl.querySelector(".pp-pedal")) {
    boardEl.removeChild(boardEl.querySelector(".pp-pedal"));
  }
  selectedInfoEl.textContent = "Nessun pedale selezionato.";
});


  if (clearBtn) {
    clearBtn.addEventListener("click", () => {
      pedals = [];
      selectedPedalId = null;
      while (boardEl.querySelector(".pp-pedal")) {
        boardEl.removeChild(boardEl.querySelector(".pp-pedal"));
      }
      selectedInfoEl.textContent = "Nessun pedale selezionato.";
    });
  }

  if (volumeToggleEl) {
    volumeToggleEl.addEventListener("change", () => {
      recalcScaleAndResize();
    });
  }

  if (volumeSideEl) {
    volumeSideEl.addEventListener("change", () => {
      updateVolumeZoneVisual();
    });
  }

  // init
  readBoardFromSelect();
  setTimeout(recalcScaleAndResize, 100);
  window.addEventListener("resize", recalcScaleAndResize);
});

